import React from 'react'
import SearchCars from "../components/SearchCars";
import { Helmet } from 'react-helmet';

function FuelFilters() {

  const pageTitle = "Филтри за гориво - Пребарување на автомобилски филтри за гориво | Filter za gorivo za tvojot avtomobil";
  const pageDescription = "Пронајди филтри за гориво за твоето возило. Погледни ги различните опции за филтри за гориво за твојот автомобили и подобри ја работата на моторот. Golem izbor na filtri za gorivo.";
  const pageKeywords = "филтри за гориво, филтри за автомобили, авто филтри, филтри за гориво за автомобил, автомобилски делови, моторни филтри";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={pageKeywords} />
      </Helmet>

      <div className='flex flex-col justify-start items-center'>
        <h1 className='text-4xl font-bold mb-8'>Филтри за гориво</h1>
        <SearchCars category={4} allFilters={false} />
      </div>
    </>
  )
}

export default FuelFilters
